document.addEventListener("DOMContentLoaded", () => {

    const tabBtns = document.querySelectorAll(".sidebar-nav__nav-button");
    
    const blocks = document.querySelectorAll(".tab-blocks__block")
    tabBtns.forEach(btn => {     
      btn.addEventListener("click", () =>{
        const section = btn.closest(".tab-blocks");
        const btnConcern = btn.dataset.concern;
        // console.log("button " + btnConcern);

        blocks.forEach(block => {
          const blockConcern = block.dataset.block;
          // console.log("block " + blockConcern)
          block.classList.toggle('active', btnConcern === blockConcern );
        })

        tabBtns.forEach(button => {
          button.classList.toggle('active', button === btn);
        });

        const offset = 125;
        const top = section.getBoundingClientRect().top + window.scrollY - offset;
        
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
        const placeholder = section.querySelector('.sidebar-nav__placeholder-text');
        if(window.innerWidth < 989 && placeholder) {
            const btnTxt = btn.textContent;
            placeholder.textContent = btnTxt;
        }
      });
    });
});